module.exports = __webpack_public_path__ + "img/11087940_L.df59f562.png";